module.exports = __webpack_public_path__ + "img/img1.560f4497.jpg";